<template>
  <TimeslotDashboardLayout>
    <template v-slot:mobile-navbar>
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
      >
        <div class="navbar1_container">
          <router-link
            to="/professional-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></router-link>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <img
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="image-profile-pic"
                      :src="customerInfo.customerDisplayPicture"
                    />
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfile" class="link-18">View profile</a>
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>

                  <router-link
                    to="/professional-classes"
                    class="link-block-4 classes w-inline-block"
                  >
                    <div class="text-block-27">My Classes</div>
                  </router-link>

                  <router-link
                    to="/professional-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/professional-availability"
                    class="link-block-4 availability w-inline-block"
                  >
                    <div class="text-block-27">Available slots</div>
                  </router-link>
                  <router-link
                    to="/professional-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/professional-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/discover-professionals"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <a
                    @click="logout"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
    </template>
    <div class="main-content support">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Support</h1>
            <div class="tab-text"></div>
            <div class="no-update_wrapper" style="display:none;">
              <div class="no-update_content">
                <img
                  src="https://uploads-ssl.webflow.com/629917a86b347b2be85e67ff/629917a86b347be87e5e6851_timer.svg"
                  loading="lazy"
                  alt=""
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Appointments with professionals would show up here
                </div>
                <a href="#" class="explore-professionals_button w-button"
                  >Explore professionals</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="support-wrapper">
        <div class="support-wrapper">
          <a
            href="mailto:support@timeslate.com"
            class="email-wrapper w-inline-block"
          >
            <img
              src="@/assets/timeslot-images/email.svg"
              loading="lazy"
              width="70"
              alt=""
            />
            <div class="text-block-104">
              Send us a mail
            </div>
          </a>
          <a
            href="https://www.instagram.com/timeslate__/"
            class="email-wrapper w-inline-block"
            ><img
              src="@/assets/timeslot-images/instagram-1.svg"
              loading="lazy"
              width="60"
              alt=""
            />
            <div class="text-block-104">Instagram</div>
          </a>
          <a
            href="https://twitter.com/Timeslate_"
            class="email-wrapper w-inline-block"
            ><img
              src="@/assets/timeslot-images/twitter-1.svg"
              loading="lazy"
              width="60"
              alt=""
            />
            <div class="text-block-104">Twitter</div>
          </a>
        </div>
      </div>
    </div>
    <template v-slot:app-navbar>
      <ProfessionalAppNavBar />
    </template>
    <template v-slot:sidebar>
      <ProfessionalSidebar />
    </template>
    <template v-slot:right-side-nav>
      <div></div>
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";

export default {
  name: "ProfessionalSupport",

  components: {
    TimeslotDashboardLayout,
    ProfessionalAppNavBar,
    ProfessionalSidebar
  },
  data() {
    return {
      bar: true,
      cross: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerInfo: state => state.customer.customerInfo
    })
  },
  methods: {
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    }
  }
};
</script>

<style scoped></style>
